import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { ConfirmationModal } from '../ConfirmationModal';
import { useOverlayContext } from '../OverlayContext';
export function UnsavedChangesModal(props) {
    const { testId, title = 'Unsaved changes', primaryButtonLabel = 'Discard changes', primaryButtonTestId, secondaryButtonTestId, content = 'You have unsaved changes that will be lost if you leave this page', dismissModal } = props;
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        testId: testId,
        skin: "danger",
        title: title,
        content: content,
        primaryButtonLabel: primaryButtonLabel,
        secondaryButtonLabel: "Keep editing",
        primaryButtonTestId: primaryButtonTestId,
        secondaryButtonTestId: secondaryButtonTestId,
        onPrimaryButtonClick: ()=>dismissModal(true),
        onSecondaryButtonClick: ()=>dismissModal(false)
    });
}
export function useOpenUnsavedChangesModal() {
    const globalContext = useOverlayContext();
    return function openUnsavedChangesModal(props) {
        return globalContext.showModal({
            closeOnClickOutside: true,
            closeOnEscapeKey: true,
            content: (param)=>{
                let { dismissModal } = param;
                return /*#__PURE__*/ _jsx(UnsavedChangesModal, _object_spread_props(_object_spread({}, props), {
                    dismissModal: dismissModal
                }));
            }
        });
    };
}
